/* BPT Back Image Finder v10.15 (strict + relaxed matching, ES5-safe) */
console.log('[BPT] back-finder loaded');

(function () {
  // ---------- utils ----------
  var COLORS=("white,black,navy,royal,red,maroon,cardinal,scarlet,orange,gold,yellow,kelly,irish,forest,olive,teal,aqua,sky,carolina,lightblue,purple,violet,lavender,pink,sand,khaki,stone,ash,athletic,heather,charcoal,silver,graphite,brown,tan,cream,natural,ivory,beige,mint,turquoise,indigo,magenta,cyan,lime,neon,safety,gray,grey").split(",");

  function norm(u){try{return decodeURIComponent(String(u)).toLowerCase()}catch(e){return String(u).toLowerCase()}}
  function filename(u){var s=String(u);var i=s.lastIndexOf("/");return i>=0?s.slice(i+1):s}
  function stem(u){var f=filename(u);var d=f.lastIndexOf(".");return(d>-1?f.slice(0,d):f).toLowerCase()}
  function ext(u){var f=filename(u);var d=f.lastIndexOf(".");return(d>-1?f.slice(d):"").toLowerCase()}
  function dir(u){var s=String(u);var i=s.lastIndexOf("/");return i>=0?s.slice(0,i+1):s}
  function hasBackWord(s){return/\b(back|backview|back-view|back_side|backside|reverse|rear)\b/i.test(s)}
  function inferColor(base,given){
    if(given&&given.length)return given.toLowerCase().replace(/\s+/g,"");
    var i,c,b=base.toLowerCase();
    for(i=0;i<COLORS.length;i++){c=COLORS[i];if(b.indexOf(c)!==-1)return c}
    return"";
  }

  // swap obvious "front/1" -> "back/2" on a stem (used for pairmate guess)
  function swapOneTwo(s){
    return s
      .replace(/front/gi,"back")
      .replace(/(^|[^0-9])1(\.|_|-|$)/g,function(m,a,b){return a+"2"+b});
  }

  // build “same-folder” candidates next to the front image
  function makeCandidates(frontUrl,colorToken){
    var s=stem(frontUrl), e=ext(frontUrl)||".jpg";
    var base=norm(s), color=inferColor(base,colorToken);
    var out={}, list=[];
    function add(name){ if(!out[name]){ out[name]=1; list.push(name); } }

    // direct swaps + explicit back names
    add(swapOneTwo(base)+e);
    add(base.replace(/front/gi,"back")+e);
    add(base.replace(/-front|_front|\sfront|\(front\)/gi,"-back")+e);
    add("back"+e); add("product-back"+e); add("image-back"+e);

    if(color){
      add(base.replace(new RegExp(color+"([_-]?)(?:1)\\b","i"),color+"$1"+"2")+e);
      add(color+"2"+e); add(color+"-2"+e); add(color+"_2"+e);
      add(color+" back"+e); add(color+"-back"+e); add(color+"_back"+e);
    }

    var d=dir(frontUrl), full=[];
    for(var i=0;i<list.length;i++) full.push(d+list[i]);
    return full;
  }

  // attempt to load an image URL -> resolves url or null
  function tryLoad(url){
    return new Promise(function(resolve){
      var img=new Image();
      img.onload=function(){ resolve(url); };
      img.onerror=function(){ resolve(null); };
      img.src=url;
    });
  }

  // STRICT / RELAXED media scorer
  // - never same as front
  // - never any filename with a visible "1" token: (^|non-digit)1(.,_,-,end)
  // - if strict and color known: require that color OR explicit "back"
  // - boosts: exact pairmate of front (1->2 / front->back), color+2, color+back, generic back, any other “2”, color mention
  function sortMediaForBack(mediaUrls, frontUrl, colorToken, strict){
    var arr=[];
    var frontClean = String(frontUrl).split('?')[0];
    var frontStemName = stem(frontClean);
    var color = (colorToken||'').toLowerCase().replace(/\s+/g,'');
    var swappedFrontStem = swapOneTwo(frontStemName); // e.g., "lsblack1" -> "lsblack2"

    for (var i=0; i<(mediaUrls||[]).length; i++){
      var u = String(mediaUrls[i]||'').split('?')[0]; if (!u) continue;
      var f = filename(u).toLowerCase();
      var s = stem(u);

      // never exact same as front
      if (s === frontStemName) continue;

      // hard block anything that looks like a "...1" (front) variant
      if (/(^|[^0-9])1(\.|_|-|$)/.test(f)) continue;

      var has2    = /(^|[^0-9])2(\.|_|-|$)/.test(f);
      var hasBack = hasBackWord(f);
      var hasClr  = color ? new RegExp("\\b"+color+"\\b").test(f) : false;
      var clr2    = color ? new RegExp("\\b"+color+"(?:_|-|\\s)?2(\\.|$)").test(f) : false;
      var clrBack = color ? new RegExp("\\b"+color+"(?:_|-|\\s)?back(\\.|$)").test(f) : false;

      // If strict and color known: require color OR explicit back to avoid mismatches.
      if (strict && color && !(hasClr || hasBack)) continue;

      var score = 0;

      // strongest: exact pairmate of front (1->2 and/or front->back), regardless of color tokens
      if (s === swappedFrontStem) score += 420;

      // color-weighted boosts
      if (clr2)      score += 400;        // "tan2"
      if (clrBack)   score += 320;        // "tan-back"

      // generic indicators
      if (hasBack)   score += 200;        // "...back..."
      if (has2)      score += 120;        // any other "...2"
      if (hasClr)    score += 40;         // color mention helps

      // mild nudge for typical product paths
      if (/\/(files|products)\//.test(u)) score += 5;

      if (score > 0) arr.push({ url:u, score:score });
    }

    arr.sort(function(a,b){ return b.score - a.score; });
    var out=[]; for (var j=0;j<arr.length;j++) out.push(arr[j].url);
    return out;
  }

  // ---------- main chooser ----------
  function pickBack(frontUrl, opts){
    opts = opts || {};
    frontUrl = String(frontUrl).split('?')[0];

    var media = Object.prototype.toString.call(opts.mediaUrls)==="[object Array]" ? opts.mediaUrls : [];
    var colorToken = opts.colorToken || "";
    var frontStem = stem(frontUrl);

    // Strict pass (color-aware), then relaxed pass (allows good matches without color token)
    var mediaStrict = sortMediaForBack(media, frontUrl, colorToken, true);
    var mediaLoose  = sortMediaForBack(media, frontUrl, colorToken, false);

    var cands = makeCandidates(frontUrl, colorToken);

    // (A1) Try strict media first
    var i=0;
    function tryMediaStrict(){
      if (i >= mediaStrict.length) return Promise.resolve(null);
      var u = String(mediaStrict[i++]).split('?')[0];
      if (stem(u) === frontStem) return tryMediaStrict();
      return tryLoad(u).then(function(ok){ return ok || tryMediaStrict(); });
    }

    // (A2) Then relaxed media
    var r=0;
    function tryMediaLoose(){
      if (r >= mediaLoose.length) return Promise.resolve(null);
      var u = String(mediaLoose[r++]).split('?')[0];
      if (stem(u) === frontStem) return tryMediaLoose();
      return tryLoad(u).then(function(ok){ return ok || tryMediaLoose(); });
    }

    // (B) Finally, same-folder generated candidates
    var j=0;
    function tryCands(){
      if (j >= cands.length) return Promise.resolve(null);
      var u = String(cands[j++]).split('?')[0];
      if (stem(u) === frontStem) return tryCands();
      if (/(^|[^0-9])1(\.|_|-|$)/.test(filename(u).toLowerCase())) return tryCands(); // skip any *1
      return tryLoad(u).then(function(ok){ return ok || tryCands(); });
    }

    return tryMediaStrict().then(function(found){
      if (found) return found;
      return tryMediaLoose();
    }).then(function(found2){
      if (found2) return found2;
      return tryCands();
    }).then(function(url){
      return url || null;
    });
  }

  // ---------- public API ----------
  window.BPT_BACK_PREFETCH = function(frontUrl, options){
    try { console.log('[BPT] prefetch start', frontUrl); } catch(e){}
    return pickBack(frontUrl, options||{}).then(function(url){
      window.BPT_BACK_IMAGE = url || null;
      try { console.log('[BPT] prefetch done', url); } catch(e){}
      try{
        var ev;
        if (typeof CustomEvent === "function") {
          ev = new CustomEvent("bpt:back-image:ready", { detail:{ url: window.BPT_BACK_IMAGE }});
        } else {
          ev = document.createEvent("CustomEvent");
          ev.initCustomEvent("bpt:back-image:ready", true, true, { url: window.BPT_BACK_IMAGE });
        }
        document.dispatchEvent(ev);
      } catch(e){}
      return url;
    });
  };
})();






